/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AddressDto } from './AddressDto';
import {
    AddressDtoFromJSON,
    AddressDtoFromJSONTyped,
    AddressDtoToJSON,
    AddressDtoToJSONTyped,
} from './AddressDto';

/**
 * 
 * @export
 * @interface InvitePatientUserRequestDto
 */
export interface InvitePatientUserRequestDto {
    /**
     * Patient email
     * @type {string}
     * @memberof InvitePatientUserRequestDto
     */
    email: string;
    /**
     * Patient first name
     * @type {string}
     * @memberof InvitePatientUserRequestDto
     */
    firstName: string;
    /**
     * Patient middle name
     * @type {string}
     * @memberof InvitePatientUserRequestDto
     */
    middleName?: string;
    /**
     * Patient last name
     * @type {string}
     * @memberof InvitePatientUserRequestDto
     */
    lastName: string;
    /**
     * Patient gender
     * @type {string}
     * @memberof InvitePatientUserRequestDto
     */
    gender: InvitePatientUserRequestDtoGenderEnum;
    /**
     * Patient birth date (YYYY-MM-DD)
     * @type {string}
     * @memberof InvitePatientUserRequestDto
     */
    birthDate: string;
    /**
     * Phone
     * @type {string}
     * @memberof InvitePatientUserRequestDto
     */
    phone?: string;
    /**
     * Emergency contact phone
     * @type {string}
     * @memberof InvitePatientUserRequestDto
     */
    emergencyContactPhone?: string;
    /**
     * Patient address
     * @type {AddressDto}
     * @memberof InvitePatientUserRequestDto
     */
    address?: AddressDto;
    /**
     * Patient shipping address
     * @type {AddressDto}
     * @memberof InvitePatientUserRequestDto
     */
    shippingAddress?: AddressDto;
}


/**
 * @export
 */
export const InvitePatientUserRequestDtoGenderEnum = {
    Male: 'male',
    Female: 'female'
} as const;
export type InvitePatientUserRequestDtoGenderEnum = typeof InvitePatientUserRequestDtoGenderEnum[keyof typeof InvitePatientUserRequestDtoGenderEnum];


/**
 * Check if a given object implements the InvitePatientUserRequestDto interface.
 */
export function instanceOfInvitePatientUserRequestDto(value: object): value is InvitePatientUserRequestDto {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('gender' in value) || value['gender'] === undefined) return false;
    if (!('birthDate' in value) || value['birthDate'] === undefined) return false;
    return true;
}

export function InvitePatientUserRequestDtoFromJSON(json: any): InvitePatientUserRequestDto {
    return InvitePatientUserRequestDtoFromJSONTyped(json, false);
}

export function InvitePatientUserRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvitePatientUserRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'firstName': json['firstName'],
        'middleName': json['middleName'] == null ? undefined : json['middleName'],
        'lastName': json['lastName'],
        'gender': json['gender'],
        'birthDate': json['birthDate'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'emergencyContactPhone': json['emergencyContactPhone'] == null ? undefined : json['emergencyContactPhone'],
        'address': json['address'] == null ? undefined : AddressDtoFromJSON(json['address']),
        'shippingAddress': json['shippingAddress'] == null ? undefined : AddressDtoFromJSON(json['shippingAddress']),
    };
}

export function InvitePatientUserRequestDtoToJSON(json: any): InvitePatientUserRequestDto {
    return InvitePatientUserRequestDtoToJSONTyped(json, false);
}

export function InvitePatientUserRequestDtoToJSONTyped(value?: InvitePatientUserRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'firstName': value['firstName'],
        'middleName': value['middleName'],
        'lastName': value['lastName'],
        'gender': value['gender'],
        'birthDate': value['birthDate'],
        'phone': value['phone'],
        'emergencyContactPhone': value['emergencyContactPhone'],
        'address': AddressDtoToJSON(value['address']),
        'shippingAddress': AddressDtoToJSON(value['shippingAddress']),
    };
}

